module.exports = __webpack_public_path__ + "img/x-circle.55475566.svg";